import FormTranslationContext from "context/FormTranslationContext";
import getObjectValue from "libs/getObjectValue";
import { useContext } from "react";
import NoticeDateInput from "../../components/inputs/NoticeDateInput";
import NoticeNumericInput from "../../components/inputs/NoticeNumericInput";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import { Collapse } from "@material-ui/core";
function ContractNotDivided(
    {
        id,
        formikProps
    }) {
    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const { getDict } = useContext(FormTranslationContext)
    const realizationPeriod = gVal("realizationPeriod");
    return (
        <>
            <NoticeDateInput
                formikProps={formikProps}
                id={gId("contractDate")}
                required
            />
            <NoticeNumericInput
                formikProps={formikProps}
                id={gId("contractValue")}
                required
            />
            <NoticeGlossaryInput
                id={gId("contractCurrency")}
                formikProps={formikProps}
                items={getDict("SL.MO.043")}
                required
            />
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("ezamowieniaNumber")}
                required
            />
            <NoticeGlossaryInput
                formikProps={formikProps}
                id={gId("realizationPeriod")}
                items={getDict("ENUM.025")}
                required
            />
            <Collapse in={realizationPeriod === "DateFromTo"}>
                <NoticeDateInput
                    formikProps={formikProps}
                    id={gId("realizationPeriodDateFrom")}
                    required
                />
            </Collapse>
            <Collapse in={realizationPeriod === "DateFromTo" || realizationPeriod === "DateTo"}>
                <NoticeDateInput
                    formikProps={formikProps}
                    id={gId("realizationPeriodDateTo")}
                    required
                />
            </Collapse>
            <Collapse in={realizationPeriod === "NumberOfDays" || realizationPeriod === "NumberOfMonths"}>
                <NoticeNumericInput
                    formikProps={formikProps}
                    id={gId("realizationPeriodAmount")}
                    required
                />
            </Collapse>

            <NoticeTextInput
                formikProps={formikProps}
                id={gId("contractorName")}
                required
            />
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("otherContractorNames")}
                multiline
            />
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("street")}
            />
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("city")}
                required
            />
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("postCode")}
            />
            <NoticeGlossaryInput
                formikProps={formikProps}
                id={gId("country")}
                items={getDict("SL.MT.005")}
                required
                unmountOnExit
            />
            <Collapse in={gVal("country") === "PL"}>
                <NoticeGlossaryInput
                    formikProps={formikProps}
                    id={gId("state")}
                    items={getDict("SL.MT.007")}
                    required
                    unmountOnExit
                />
            </Collapse>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("nip")}
            />
        </>
    )
}

ContractNotDivided.propTypes = {};
export default ContractNotDivided;